

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';
  showText?: boolean;
  className?: string;
  userType?: 'admin' | 'subcontractor';
}

export function Logo({ size = 'md', showText = false, className = '', userType }: LogoProps) {
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
    xl: 'h-20 w-20',
    '2xl': 'h-24 w-24',
    '3xl': 'h-32 w-32',
    '4xl': 'h-40 w-40'
  };

  const textSizes = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
    '2xl': 'text-2xl',
    '3xl': 'text-3xl',
    '4xl': 'text-4xl'
  };

  const userTypeText = userType === 'admin' ? 'Administratör' : userType === 'subcontractor' ? 'Trädgårdsmästare' : '';

  return (
    <div className={`logo ${className}`}>
      {/* PNG Logo */}
      <img
        src="/logo.png"
        alt="Trädgård Support Logo"
        className={`${sizeClasses[size]} logo-icon object-contain`}
      />
      
      {showText && (
        <div className="ml-3 flex flex-col justify-center">
          <span className={`logo-text ${textSizes[size]} font-bold text-nature-900 dark:text-nature-100 leading-tight transition-colors duration-200`}>
            MB Trädgård Support AB
          </span>
          {userType && (
            <span className="text-sm text-nature-600 dark:text-nature-300 mt-1 leading-tight transition-colors duration-200">
              {userTypeText}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
